import React from 'react';
import { Calendar, Clock, CalendarCheck, Percent, FileText } from 'lucide-react';
export function TenancySchedule() {
  return <section className="w-full flex flex-col lg:flex-row" data-id="element-80">
      {/* Left: Schedule Data */}
      <div className="w-full lg:w-1/2 bg-[#E8A020] py-20 px-6 lg:px-12 flex flex-col justify-center" data-id="element-81">
        <div className="max-w-xl mx-auto w-full" data-id="element-82">
          <h2 className="text-4xl md:text-5xl font-bold text-[#1A1A1A] mb-12 tracking-tight" data-id="element-83">
            Tenancy Schedule
          </h2>

          <div className="space-y-8" data-id="element-84">
            <div className="grid grid-cols-2 gap-8 pb-8 border-b border-[#1A1A1A]/10" data-id="element-85">
              {/* Item 1 */}
              <div data-id="element-86">
                <div className="flex items-center gap-2 mb-2 text-[#1A1A1A]/60" data-id="element-87">
                  <Calendar className="w-4 h-4" data-id="element-88" />
                  <h3 className="text-xs font-bold uppercase tracking-wider" data-id="element-89">
                    Lease Comm.
                  </h3>
                </div>
                <p className="text-[#1A1A1A] text-2xl font-light" data-id="element-90">11-Nov-25</p>
              </div>

              {/* Item 2 */}
              <div data-id="element-91">
                <div className="flex items-center gap-2 mb-2 text-[#1A1A1A]/60" data-id="element-92">
                  <Clock className="w-4 h-4" data-id="element-93" />
                  <h3 className="text-xs font-bold uppercase tracking-wider" data-id="element-94">
                    Lease Term
                  </h3>
                </div>
                <p className="text-[#1A1A1A] text-2xl font-light" data-id="element-95">3 Years</p>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-8 pb-8 border-b border-[#1A1A1A]/10" data-id="element-96">
              {/* Item 3 */}
              <div data-id="element-97">
                <div className="flex items-center gap-2 mb-2 text-[#1A1A1A]/60" data-id="element-98">
                  <CalendarCheck className="w-4 h-4" data-id="element-99" />
                  <h3 className="text-xs font-bold uppercase tracking-wider" data-id="element-100">
                    Lease Expiry
                  </h3>
                </div>
                <p className="text-[#1A1A1A] text-2xl font-light" data-id="element-101">10-Nov-28</p>
              </div>

              {/* Item 4 */}
              <div data-id="element-102">
                <div className="flex items-center gap-2 mb-2 text-[#1A1A1A]/60" data-id="element-103">
                  <Percent className="w-4 h-4" data-id="element-104" />
                  <h3 className="text-xs font-bold uppercase tracking-wider" data-id="element-105">
                    Reviews
                  </h3>
                </div>
                <p className="text-[#1A1A1A] text-2xl font-light" data-id="element-106">3.5%</p>
              </div>
            </div>

            {/* Item 5 */}
            <div data-id="element-107">
              <div className="flex items-center gap-2 mb-2 text-[#1A1A1A]/60" data-id="element-108">
                <FileText className="w-4 h-4" data-id="element-109" />
                <h3 className="text-xs font-bold uppercase tracking-wider" data-id="element-110">
                  Further Terms
                </h3>
              </div>
              <p className="text-[#1A1A1A] text-2xl font-light" data-id="element-111">1 x 3 Years</p>
            </div>
          </div>
        </div>
      </div>

      {/* Right: Drone Image */}
      <div className="w-full lg:w-1/2 h-[500px] lg:h-auto relative bg-gray-200" data-id="element-112">
        <img src="https://cdn.magicpatterns.com/uploads/817tM8Ktb3ZMhngdbPFanT/Screenshot_2026-02-19_at_11.42.39_AM.png" alt="401 Chapel Street South Yarra - Aerial View" className="absolute inset-0 w-full h-full object-cover" data-id="element-113" />
      </div>
    </section>;
}